var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal is-active"},[(_vm.id)?_c(_vm.dynamicComponent,{tag:"component",attrs:{"data":_vm.config}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }